"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelpIconType = void 0;
var HelpIconType;
(function (HelpIconType) {
    // Game design
    HelpIconType["START_BACKGROUND_IMAGE"] = "START_BACKGROUND_IMAGE";
    HelpIconType["SPRITE_SHEET"] = "SPRITE_SHEET";
    HelpIconType["HIGH_SOCRE"] = "HIGH_SOCRE";
    HelpIconType["QUIZE"] = "QUIZE";
    // Game setting
    HelpIconType["SPLIT_GAMES"] = "SPLIT_GAMES";
    HelpIconType["INSTRUCTION_VIEW"] = "INSTRUCTION_VIEW";
    HelpIconType["VIEWS"] = "VIEWS";
    HelpIconType["ADDITIONAL_TERMS"] = "ADDITIONAL_TERMS";
    HelpIconType["PRIZES"] = "PRIZES";
    HelpIconType["WINNER_PRIZES"] = "WINNER_PRIZES";
    HelpIconType["CHALLENGE"] = "CHALLENGE";
    HelpIconType["REWARD_TYPE"] = "REWARD_TYPE";
    HelpIconType["CHALLENGE_UNIQUE_IDENTIFIER"] = "CHALLENGE_UNIQUE_IDENTIFIER";
    HelpIconType["REWARD_IN_GAME"] = "REWARD_IN_GAME";
    HelpIconType["MULTI_ENTRY"] = "MULTI_ENTRY";
    HelpIconType["BUILD_USER_BASE"] = "BUILD_USER_BASE";
    HelpIconType["USER_BASE_UNIQUE_IDENTIFIER"] = "USER_BASE_UNIQUE_IDENTIFIER";
    HelpIconType["PARAMETER"] = "PARAMETER";
    HelpIconType["LUCK_BASED_WINS_ACTIVATE"] = "LUCK_BASED_WINS_ACTIVATE";
    HelpIconType["LUCK_BASED_WINS_SCORE_CONDITION"] = "LUCK_BASED_WINS_SCORE_CONDITION";
    HelpIconType["LUCK_BASED_WINS_REWARD_TYPE"] = "LUCK_BASED_WINS_REWARD_TYPE";
    HelpIconType["LUCK_BASED_WINS_CHANCE_TO_WIN"] = "LUCK_BASED_WINS_CHANCE_TO_WIN";
    HelpIconType["LUCK_BASED_WINS_REWARD_LIMIT"] = "LUCK_BASED_WINS_REWARD_LIMIT";
    HelpIconType["LUCK_BASED_WINS_POPUP"] = "LUCK_BASED_WINS_POPUP";
    // Game center setting
    HelpIconType["ACTIVE_WALLET"] = "ACTIVE_WALLET";
    HelpIconType["USER_BASE_AND_LOGIN_BUILD_USER_BASE"] = "USER_BASE_AND_LOGIN_BUILD_USER_BASE";
    HelpIconType["BUILD_USER_BASE_WITH_IDENTIFIER"] = "BUILD_USER_BASE_WITH_IDENTIFIER";
    // Modules
    HelpIconType["GAME_MODULE"] = "GAME_MODULE";
    HelpIconType["TEXT_MODULE"] = "TEXT_MODULE";
    HelpIconType["AD_MODULE"] = "AD_MODULE";
    HelpIconType["REWARD_MODULE"] = "REWARD_MODULE";
    //Receipts
    HelpIconType["GENERAL_PLAYER_IDENTIFIER"] = "GENERAL_PLAYER_IDENTIFIER";
    HelpIconType["GENERAL_ADDITIONAL_TERMS_TEXT"] = "GENERAL_ADDITIONAL_TERMS_TEXT";
    HelpIconType["CONDITIONS"] = "CONDITIONS";
    HelpIconType["PRODUCTS"] = "PRODUCTS";
    HelpIconType["STORES"] = "STORES";
})(HelpIconType || (exports.HelpIconType = HelpIconType = {}));
